import axios from "axios";
import {Storage} from "@/Services/Storage";
import queryStringify from "qs-stringify";
import {base64ToBlob, cleanAndValidateDates, openFile, sanitizeDate} from "@/Services/utils";

export default {
    name: 'Debtor',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        createDebtor: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (storeDB === `burntofi_chrilan`){
                payload.CellNumber = payload.CellNumber.replace(`+`,``);
            }
            return axios.post(serverApi + `debtor/${storeDB}`, payload)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err));
        },
        async printPDFInvs(_, extraData) {
            try {
                // 1. First get the raw response
                const response = await axios.post(
                    lytSoftRushApi + 'rush/download',
                    extraData,
                    {
                        responseType: 'arraybuffer', // Get raw binary data
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then().catch((err) => {
                    if(err?.message) {
                        return Swal.fire({
                            title: 'Download Failed',
                            text: `Error :: ${err?.message}`,
                            icon: 'error',
                            confirmButtonText: 'OK',
                        })
                    }
                    errorHandler.tomcatError(err)
                })

                // 2. Create Blob directly from arraybuffer
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

                // 3. Create mock response for openFile
                const mockResponse = {
                    data: pdfBlob,
                    headers: {
                        'content-type': 'application/pdf'
                    }
                };

                const fileName = `Bulk_Invoices`;
                openFile(mockResponse, fileName);

                return true;
            } catch (err) {
                console.error('Error fetching PDF:', err);
                errorHandler.tomcatError(err);
                throw err;
            }
        },

        getAllDebtors: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.post(franchiseTomcatApi + `debtor/${storeDB}/search`, payload)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        getDebtorBalances: async (context, IDs) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let obj = {IDs}
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/getDebtorBalances`, obj)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err));
        },
        getDebtorByID: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(onlineSalesTomcatApi + `debtor/${storeDB}/${id}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        getDebtorBalance: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `debtor/${storeDB}/VerifyBalance?ID=${id}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        getInvoicesByDebtor: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let payload = context.getters.getGlobalDateRange;
            payload.id = id;
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/invoices`, payload)
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },

        getCreditNotesByDebtor: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let payload = context.getters.getGlobalDateRange;
            payload.id = id;
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/CreditNotes`, payload)
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },

        getPaymentsByDebtor: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let payload = context.getters.getGlobalDateRange;
            payload.id = id;
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/Payments`, payload)
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },

        getSmartRushGroup: async (context) => {
            return axios.get(lytSoftRushApi + `rush/groups`)
                .then(({data}) => {
                   return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        getProductsBoughtByDebtor: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let payload = context.getters.getGlobalDateRange;
            payload.id = id;
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/getProductsBought`, payload)
                .then(({data}) => {
                    return data
                }).catch((err) => errorHandler.tomcatError(err))
        },

        getQuotesByDebtor: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let obj = {
                Name: ``,
                customerID: id,
            };
            return axios.post(franchiseTomcatApi + `savetable/${storeDB}/search`, obj)
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },
        printDebtorStatement: async (context, id) => {
      let storeDB = await Storage.getCurrentStoreDB();
      let payload = context.getters.getGlobalDateRange;
      payload.id = id;
      let user = await Storage.getCurrentUser()
      payload.User = user.Username;
      payload.from = sanitizeDate(payload.from);
      payload.to = sanitizeDate(payload.to);
      let url = printApi + `debtor/${storeDB}/getMinistatement?`+ stringify(payload);
      return openUrl(url);
    },

        getBatchesByRange: async (context, extraData) => {
            let payload = context.getters.getGlobalDateRange;

            return axios.get(lytSoftRushApi + `rush/stats?group=${extraData.group}&from=${payload.from}&to=${payload.to}&limit=${extraData.limit}`)
                .then(({data}) => {
                    return data
                }).catch((err) => errorHandler.tomcatError(err))

        },
       deleteBulkSingleInvoice: async (context, id) => {
           return axios.post(lytSoftRushApi + `rush/delete?id=${id}`)
               .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
       },
        deleteBulkBatch: async (context, id) => {
            return axios.post(lytSoftRushApi + `rush/delete-batch/${id}`)
              .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },
        excelDebtorStatement: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let payload = context.getters.getGlobalDateRange;
            payload.from = sanitizeDate(payload.from);
            payload.to = sanitizeDate(payload.to);
            payload = queryStringify(payload);
            return openUrl(franchiseApi + `account/exportStatement/${id}/${storeDB}?` + payload);
        },

        exportCustomerList: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return openUrl(franchiseApi + `account/exportCustomerList/${storeDB}?` + stringify(payload));
        },

        exportQuotesList: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return openUrl(franchiseApi + `account/exportQuotes/${storeDB}?` + stringify(payload));
        },


        makeDebtorPayment: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            payload.User = user.Username;
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/makePayment`, payload)
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },

        /**
         * Make a payment directly against a specific invoice
         * @param {Object} _ - Vuex context (unused)
         * @param {Object} payload
         * @param {string} payload.invoiceNumber - Invoice number (e.g. INV-2025-0001)
         * @param {string} payload.paidFrom - Account/safe name (e.g. Main Safe)
         * @returns {Promise<Object>} API response with payment id
         */
        makeInvoicePayment: async (_, { invoiceNumber, paidFrom }) => {
            const storeDB = await Storage.getCurrentStoreDB();
            const user = await Storage.getCurrentUser();
            const body = {
                paidFrom,
                user: user.Username,
                invoiceNumber
            };
            return axios
                .post(backOfficeTomcatApi + `Payments/${storeDB}/accountInvoicePayment`, body)
                .then(({ data }) => data)
                .catch((err) => errorHandler.tomcatError(err));
        },

        creditAccountPayment: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            user = user.Username;
            let obj = {user, id};
            return axios.post(backOfficeTomcatApi + `Payments/${storeDB}/returnAccountPayment`, obj)
                .catch((err) => errorHandler.tomcatError(err))
        },

        createQuote: async (context, debtorDetails = null) => {
            let user = await Storage.getCurrentUser();
            let mobileUser = await Storage.getMobileUser()
            let store = await Storage.getCurrentStore()

            let obj = {
                user: user.Username,
                mobileUser: mobileUser,
                store: store
            };
            if (debtorDetails) {
                obj.customerID = debtorDetails.customerID
                obj.currency = debtorDetails.currency;
                obj.debtors = debtorDetails.debtors
                obj.quoteID = debtorDetails.quoteID
            }
            obj = JSON.stringify(obj);
            obj = window.btoa(obj);
             // return openUrl(`http://192.168.1.208:8081/?quoteData=` + obj);
            return openUrl(`${dsrApi}?quoteData=` + obj);
        },
        convertQuoteToInvoice: async (context, saleNumber) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            return Swal.fire({
                icon: `question`,
                title: `Reference`,
                input: `text`,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: async (inputValue) => {
                    let payload = {
                        user: user.Username,
                        saleNumber: saleNumber,
                        reference: inputValue,
                    }
                    return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/convertQuoteToInvoice`, payload)
                        .then(({data}) => data.response.invoice)
                        .catch((err) => errorHandler.tomcatError(err))
                }
            }).then(result => {
                if (result.isConfirmed) {
                    return result.value;
                }
                return false;
            });
        },

        exportQuoteToInvoice: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            user = user.Username;
            payload = {
                user,
                ...payload
            };
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/convertQuoteToInvoice`, payload)
                .then(({data}) => {
                    context.dispatch(`printInvoice`,{
                        invoice : data.response.invoice,
                        reprint : false,
                    });
                })
                .catch((err) => errorHandler.tomcatError(err))

        },

        creditEntireInvoice: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            payload.user = user.Username;
            payload.PC = `Online`;
            $utils.showLoading()
            try {
                const {data} = await axios.post(onlineSalesTomcatApi + `invoice/${storeDB}/creditEntireAccountInvoice`, payload);
                return data.response.invoice;
            } catch (err) {
                errorHandler.tomcatError(err);
                throw err;
            } finally {
                $utils.hideLoading();
            }
        },

        printAccountPayment: async (context, id) => {
      let storeDB = await Storage.getCurrentStoreDB();
      let user = await Storage.getCurrentUser();
      let obj = {
        PaymentID: id,
        User: user.Username,
      }
      obj = queryStringify(obj);
      return openUrl(printApi + `debtor/${storeDB}/openPayment?` + obj);
    },

        getTotalOwed: async () => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `debtor/${storeDB}/getTotalOwed`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        getQuotedTotal: async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let obj = context.getters.getGlobalDateRange;
            let user = await Storage.getCurrentUser();
            obj.User = user.Username;
            return axios.get(backOfficeTomcatApi + `debtor/${storeDB}/getQuotedTotal`, {params: obj})
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },
        deleteQuote: async (context, saleNumber) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.delete(serverApi + `tables/${storeDB}/void/${saleNumber}`)
                .catch((err) => errorHandler.tomcatError(err))
        },
        deleteDeliveryNote: async (context, saleNumber) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            user = user.Username;
            return axios.delete(backOfficeTomcatApi + `deliveryNotes/${storeDB}/${saleNumber}?user=${user}`)
                .catch((err) => errorHandler.tomcatError(err))
        },
         getAllQuotes: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            let obj = {
                ...context.getters.getGlobalDateRange,
                ...payload,
                User: !payload.User ? user.Username : payload.User,
            };
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/searchAllQuotes`, obj)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        getAllQuotes2: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            let obj = {
                ...context.getters.getGlobalDateRange,
                ...payload,
                User: !payload.User ? user.Username : payload.User,
            };
            return axios.post(backOfficeTomcatApi + `debtor/${storeDB}/searchAllQuotes`, obj)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        async getAllInvoices(context, payload) {
            let store = await Storage.getCurrentStoreDB();
            payload = {
                ...context.getters.getGlobalDateRange,
                ...payload
            }
            return axios.post(backOfficeTomcatApi + `other/${store}/searchSales`, payload)
                .then(({data}) => {
                    const list = Array.isArray(data) ? data : [];
                    return list.map(inv => ({
                        ...inv,
                        // Normalize isSapInvoice to strict boolean: true for true/1/'1'
                        isSapInvoice: inv?.isSapInvoice === true || inv?.isSapInvoice === 1 || inv?.isSapInvoice === '1',
                    }));
                })
                .catch((err) => errorHandler.tomcatError(err))
        },

        /**
         * Retry posting a non-SAP invoice to SAP.
         * Online Sales Server: POST /invoice/{DB}/sap/retry/{invoiceNumber}
         * Optional body: { reason?: string }
         * @param context
         * @param {{ invoiceNumber: string, reason?: string }} payload
         * @returns {Promise<object|void>}
         */
        async retrySapInvoice(context, { invoiceNumber, reason } = {}) {
            try {
                const storeDB = await Storage.getCurrentStoreDB();
                if (!window.isValidString(storeDB)) throw new Error('Missing store DB');
                if (!window.isValidString(invoiceNumber)) throw new Error('Missing invoice number');
                const url = `${window.serverApi}invoice/${encodeURIComponent(storeDB)}/sap/retry/${encodeURIComponent(invoiceNumber)}`;
                const body = reason ? { reason } : undefined;
                const { data } = await axios.post(url, body);
                const msg = data?.message || `Retry requested for ${invoiceNumber}`;
                window.Toast?.fire({ icon: 'success', title: msg });
                return data;
            } catch (err) {
                errorHandler.tomcatError(err);
            }
        },

        /**
         * Get invoice items by invoice ID
         * @param {Object} context - Vuex context
         * @param {string} invId - Invoice ID
         * @returns {Promise<Object>} Invoice items data
         */
        getInvoiceItems: async (context, invId) => {
            const storeDB = await Storage.getCurrentStoreDB();
            return axios.get(franchiseTomcatApi + `completedsale/${storeDB}/getInvNum?invoice=${invId}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err));
        },

        /**
         * Process invoice credit (either entire invoice or selected items)
         * @param {Object} context - Vuex context
         * @param {Object} payload - Credit invoice data
         * @param {boolean} payload.creditEntireInvoice - Whether to credit entire invoice
         * @param {Object} payload.data - Data for entire invoice credit
         * @param {Object} payload.invoiceData - Data for partial invoice credit
         * @returns {Promise<Object>} Credit response
         */
        processInvoiceCredit: async (context, payload) => {
            const storeDB = await Storage.getCurrentStoreDB();
            const endpoint = payload.creditEntireInvoice
                ? `invoice/${storeDB}/creditEntireAccountInvoice`
                : `invoice/${storeDB}/mobile?android=true`;

            return axios.post(serverApi + endpoint, payload.creditEntireInvoice ? payload.data : payload.invoiceData)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err));
        },

        /**
         * Get invoice data by invoice number
         * @param {Object} context - Vuex context
         * @param {Object} payload - Invoice data payload
         * @param {string} payload.invNumber - Invoice number
         * @param {boolean} payload.reprint - Whether this is a reprint
         * @returns {Promise<Object>} Invoice data
         */
        getInvoiceData: async (context, payload) => {
            const storeDB = await Storage.getCurrentStoreDB();
            const { invNumber, reprint = false } = payload;
            return axios.get(franchiseTomcatApi + `invnumandi/${invNumber}/db/${storeDB}?invData=false&rawBt=false&reprint=${reprint}&pc=Online`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err));
        },
    }
}
